import React from 'react';
import { useAuth } from '../../providers/auth-provider';

function CandidateCompareHeader() {
  const { isSelect } = useAuth();
  return (
    <div className="d-flex pt-4 pb-2 w-100 justify-content-center sticky-top bg-light">
      {isSelect() ? <h1 className="display-4">Candidate Compare</h1> : <h1 className="display-4">Leader Compare</h1>}
    </div>
  );
}

export default CandidateCompareHeader;
